export default "__VITE_PUBLIC_ASSET__c0debe86__"